import './App.css';
import {
  TopBar,
  NavBar,
  Home,
  Services,
  About,
  Contact,
  Footer,
  NotFound
} from './components';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Router>
        <TopBar/>
        <NavBar/>
        <Routes>
          <Route exact path="/" element={<Home />}/>
          <Route path="/services" element={<Services />}/>
          <Route path="/about" element={<About variant="full" />}/>
          <Route path="/contact" element={<Contact page />}/>
          <Route path="*" element={<NotFound />}/>
        </Routes>
        <Footer/>
      </Router>
    </div>
  );
}

export default App;
